import React from 'react'
import { CommandItem } from 'cmdk'

import { CheckIcon } from '../Icon'

export interface SmartSelectItemImageProps extends Omit<React.ComponentProps<typeof CommandItem>, 'key'> {
  active: boolean
  image?: string
  label: string
}

export const SmartSelectItemImage = ({
  active = false,
  image,
  label,
  onSelect,
  value
}: SmartSelectItemImageProps): JSX.Element => {
  return (
    <CommandItem key={value} value={value} data-active={active} data-variant={'image'} onSelect={onSelect}>
      <div data-name="image-label-wrap">
        {image ? (
          <img
            src={image}
            alt={label}
            width={43}
            height={32}
            style={{
              aspectRatio: '43 / 32',
              objectFit: 'cover',
              backgroundColor: 'light-dark(var(--brand-grey-100), var(--brand-grey-400))',
              borderRadius: '3px'
            }}
          />
        ) : null}
        {label}
      </div>
      <CheckIcon color={'blue300'} role="presentation" />
    </CommandItem>
  )
}
